import { ReactNode } from 'react';

import Tooltip from '@mui/material/Tooltip';

import { useTranslate } from 'src/locales';

import { getApplicationSource, ApplicationSourceFields } from './application-source';

type Props = {
  application: ApplicationSourceFields;
  // Shown when the source is unknown. Defaults to "Unknown".
  fallback?: ReactNode;
};

/**
 * An application's source as inline text. An imported application shows its job board with an
 * asterisk, and the tooltip says it came through the application import.
 */
export default function ApplicationSourceLabel({ application, fallback }: Props) {
  const { t } = useTranslate();

  const { label, viaImport } = getApplicationSource(application, t);

  if (!label) {
    return <>{fallback ?? t('common.unknown')}</>;
  }

  if (!viaImport) {
    return <>{label}</>;
  }

  return (
    <Tooltip title={t('applications.source.via_import')}>
      <span>{label}*</span>
    </Tooltip>
  );
}
